import { Trash2, Loader2 } from "lucide-react";
import { useState } from "react";
import inviteusersService from "../services/invite-users.service";
import toast from "react-hot-toast";

const RevokeConfirmationModal = ({
  isOpen,
  onClose,
  userName,
  userId,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  userName: string;
  userId: string;
  onConfirm: () => void;
}) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const confirmRevoke = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      await inviteusersService.revokeInvite(userId);
      toast.success("Invitation revoked successfully!");
      onConfirm();
      setLoading(false);
    } catch (error) {
      console.error("Failed to revoke invite:", error);
      if (error?.response?.data?.error?.error_description) {
          toast.error(error?.response?.data?.error?.error_description);
        } else if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error("Failed to revoke invite");
        }
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-auto">
        <div className="p-8 flex flex-col items-center text-center">
          <div className="mb-4">
            <Trash2 className="w-12 h-12 text-blue-600" />
          </div>

          <h2 className="text-2xl font-semibold text-gray-700 mb-2">
            Revoke invite!
          </h2>

          <p className="text-gray-500 mb-6">
            Are you sure you want to revoke the invitation for <b>{userName}</b>?
          </p>

          <div className="flex gap-4 w-full">
            {/* Cancel Button */}
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-sm font-medium disabled:opacity-50"
            >
              Cancel
            </button>

            {/* Yes Button */}
            <button
              type="button"
              onClick={confirmRevoke}
              disabled={loading}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium disabled:opacity-50"
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Yes</span>
                </div>
              ) : (
                "Yes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevokeConfirmationModal;
